/** Test hooks, kept in one place so drivers and specs share one source. */
export const RentalsListDataHooks = {
  root: 'rentals-list-root',
  title: 'rentals-list-title',
  grid: 'rentals-list-grid',
  card: 'rentals-list-card',
  media: 'rentals-list-media',
  mediaFallback: 'rentals-list-media-fallback',
  unitBadge: 'rentals-list-unit-badge',
  serviceName: 'rentals-list-service-name',
  price: 'rentals-list-price',
  durationRange: 'rentals-list-duration-range',
  tagline: 'rentals-list-tagline',
  taglineMoreInfo: 'rentals-list-tagline-more-info',
  bookButton: 'rentals-list-book-button',
  loadMore: 'rentals-list-load-more',
  emptyState: 'rentals-list-empty-state',
  errorState: 'rentals-list-error-state',
  searchBar: 'rentals-list-search-bar',
  searchLocation: 'rentals-list-search-location',
  searchDate: 'rentals-list-search-date',
  searchDatePopover: 'rentals-list-search-date-popover',
  searchDateApply: 'rentals-list-search-date-apply',
  searchSubmit: 'rentals-list-search-submit',
  filtersBar: 'rentals-list-filters-bar',
  filtersButton: 'rentals-list-filters-button',
  resourceTypeFilter: 'rentals-list-resource-type-filter',
  resourceTypeScrollStart: 'rentals-list-resource-type-scroll-start',
  resourceTypeScrollEnd: 'rentals-list-resource-type-scroll-end',
  filtersModal: 'rentals-list-filters-modal',
  filtersModalClose: 'rentals-list-filters-modal-close',
  filtersModalApply: 'rentals-list-filters-modal-apply',
  filtersModalClearAll: 'rentals-list-filters-modal-clear-all',
  resultsPreferences: 'rentals-list-results-preferences',
  resultsAvailabilityToggle: 'rentals-list-results-availability-toggle',
  attributeBooleanChip: 'rentals-list-attribute-boolean-chip',
  attributeEnumChip: 'rentals-list-attribute-enum-chip',
  attributeNumberRange: 'rentals-list-attribute-number-range',
  rentalBasisCheckbox: 'rentals-list-rental-basis-checkbox',
  paymentOptionCheckbox: 'rentals-list-payment-option-checkbox',
} as const;
